import styled from "styled-components";
export const Oblique = styled.span `
  font-style: oblique;
  position: relative;
`;
